











import { Component, Prop, Vue } from 'vue-property-decorator';
import { IProgress, StringOrNumber, StyleParam } from './types';

@Component
export default class Progress extends Vue implements IProgress {
  @Prop({ type: [String, Number], default: 50 })
  readonly value!: StringOrNumber;

  @Prop({ type: Number, default: 0 })
  readonly min!: number;

  @Prop({ type: Number, default: 100 })
  readonly max!: number;

  get position(): number {
    const { value } = this;
    if (typeof value !== 'string' && typeof value !== 'number') return 0;
    if (typeof value !== 'string') return value;
    return parseInt(value, 10);
  }

  get rangePosition(): boolean {
    const { position, min, max } = this;
    return min < position && max >= position;
  }

  get transformPosition(): StyleParam {
    const { rangePosition, value } = this;
    return rangePosition ? { width: `${value}%` } : {};
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/smart/components/item/components/progress/Progress.vue